// External globals — accessed lazily because legacy-utils loads after codes.ts
const _w = window as any;

export class Codes {
    private static States: Array<{ code: string, value: string }> = [];
    private static DispositionCodes: Array<{ code: number, value: string }> = [];
    private static VehicleTypes: Array<{ code: number, value: string }> = [];
    private static GenderCodes: Array<{ code: number, value: string }> = [];
    private static PersonCodes: Array<{ code: number, value: string }> = [];
    private static RelationshipTypes: Array<{ code: number, value: string }> = [];
    private static CountryCodes: Array<{ code: string, value: string }> = [];
    private static RaceCodes: Array<{ code: number, value: string, visible: Array<string>, order: number }> = [];
    private static EyeColorCodes: Array<{ code: number, value: string }> = [];
    private static HairColorCodes: Array<{ code: number, value: string }> = [];
    private static DigitalEvidenceCodes: Array<{ code: number, value: string }> = [];
    private static PropertyCodes: Array<{ code: number, value: string }> = [];
    private static NotifiedPersonAsCodes: Array<{ code: number, value: string }> = [];
    private static HowReceivedCodes: Array<{ code: number, value: string }> = [];
    private static SubmoduleRoleCodes: Array<{ code: number, value: string }> = [];
    private static KerktonRoleCodes: Array<{ code: number, value: string }> = [];
    private static OffenseCodes: Array<{ code: number, value: string, sgCode: number, gCode: number, mgCode: number }> = [];
    private static NoteRecipientCodes: Array<{ code: string, value: string }> = [];
    private static PhoneTypeCodes: Array<{ code: string, value: string }> = [];
    private static EmailTypeCodes: Array<{ code: string, value: string }> = [];

    static cleanUp(): void {
        this.States = [];
        this.DispositionCodes = [];
        this.VehicleTypes = [];
        this.GenderCodes = [];
        this.PersonCodes = [];
        this.RelationshipTypes = [];
        this.CountryCodes = [];
        this.RaceCodes = [];
        this.EyeColorCodes = [];
        this.HairColorCodes = [];
        this.DigitalEvidenceCodes = [];
        this.PropertyCodes = [];
        this.NotifiedPersonAsCodes = [];
        this.HowReceivedCodes = [];
        this.SubmoduleRoleCodes = [];
        this.KerktonRoleCodes = [];
        this.OffenseCodes = [];
        this.NoteRecipientCodes = [];
        this.PhoneTypeCodes = [];
        this.EmailTypeCodes = [];
    }

    private static fillCodesFromAuthObject(): void {
        const authObj: any = _w.getAuthObject();
        const rsCodes = authObj.rsCodes;

        //add blank line to start of states codes
        if (rsCodes.stateCodes.length > 0 && rsCodes.stateCodes[0].code !== "") {
            rsCodes.stateCodes.unshift({ code: "", value: "" });
        }
        this.States = rsCodes.stateCodes;
        this.DispositionCodes = rsCodes.dispositionCodes;
        this.VehicleTypes = rsCodes.vehicleCodes;
        //Move "Unknown" item of Vehicle Types to the end of the list
        const idxOfVehicleTypeUnknown = _w.indexOfValueInArrayByProperty(this.VehicleTypes, 'value', 'Unknown');
        if (idxOfVehicleTypeUnknown !== -1) {
            const vehicleTypeUnknown = this.VehicleTypes[idxOfVehicleTypeUnknown];
            this.VehicleTypes.splice(idxOfVehicleTypeUnknown, 1);
            this.VehicleTypes.push(vehicleTypeUnknown);
        }
        this.GenderCodes = rsCodes.genderCodes;
        this.PersonCodes = rsCodes.personCodes;
        this.RelationshipTypes = rsCodes.relationshipCodes;
        this.CountryCodes = rsCodes.countryCodes;
        this.RaceCodes = rsCodes.raceCodes;
        this.EyeColorCodes = rsCodes.eyeColorCodes;
        this.HairColorCodes = rsCodes.hairColorCodes;
        this.DigitalEvidenceCodes = rsCodes.digitalEvidenceCodes;
        this.PropertyCodes = rsCodes.propertyCodes;
        this.NotifiedPersonAsCodes = rsCodes.notifiedPersonAsCodes;
        this.HowReceivedCodes = rsCodes.howReceivedCodes;
        this.SubmoduleRoleCodes = rsCodes.submoduleRoleCodes;
        this.KerktonRoleCodes = rsCodes.kerktonRoleCodes;
        this.OffenseCodes = rsCodes.offenseCodes;
        this.NoteRecipientCodes = rsCodes.noteRecipientCodes;
        this.PhoneTypeCodes = rsCodes.phoneTypeCodes || [];
        this.EmailTypeCodes = rsCodes.emailTypeCodes || [];
    }

    static getStates(): Array<{ code: string, value: string }> { if (this.States.length === 0) { this.fillCodesFromAuthObject(); } return this.States; }
    static getDispositionCodes(): Array<{ code: number, value: string }> { if (this.DispositionCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.DispositionCodes; }
    static getVehicleTypes(): Array<{ code: number, value: string }> { if (this.VehicleTypes.length === 0) { this.fillCodesFromAuthObject(); } return this.VehicleTypes; }
    static getGenderCodes(): Array<{ code: number, value: string }> { if (this.GenderCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.GenderCodes; }
    static getPersonCodes(): Array<{ code: number, value: string }> { if (this.PersonCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.PersonCodes; }
    static getRelationshipTypes(): Array<{ code: number, value: string }> { if (this.RelationshipTypes.length === 0) { this.fillCodesFromAuthObject(); } return this.RelationshipTypes; }
    static getCountryCodes(): Array<{ code: string, value: string }> { if (this.CountryCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.CountryCodes; }
    static getRaceCodes(): Array<{ code: number, value: string, visible: Array<string>, order: number }> { if (this.RaceCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.RaceCodes; }
    static getEyeColorCodes(): Array<{ code: number, value: string }> { if (this.EyeColorCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.EyeColorCodes; }
    static getHairColorCodes(): Array<{ code: number, value: string }> { if (this.HairColorCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.HairColorCodes; }
    static getDigitalEvidenceCodes(): Array<{ code: number, value: string }> { if (this.DigitalEvidenceCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.DigitalEvidenceCodes; }
    static getPropertyCodes(): Array<{ code: number, value: string }> { if (this.PropertyCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.PropertyCodes; }
    static getNotifiedPersonAsCodes(): Array<{ code: number, value: string }> { if (this.NotifiedPersonAsCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.NotifiedPersonAsCodes; }
    static getNotifiedPersonAsCodesWithOtherLast(): Array<{ code: number, value: string }> {
        const notifiedPersonAsCodes = Codes.getNotifiedPersonAsCodes()
        const idxOfOther: number = 3; //This should never change as it is hard-coded in the Back End.
        return notifiedPersonAsCodes.slice(0, idxOfOther - 1).concat(notifiedPersonAsCodes.slice(idxOfOther)).concat(notifiedPersonAsCodes.slice(idxOfOther - 1, idxOfOther));
    }
    static getHowReceivedCodes(): Array<{ code: number, value: string }> { if (this.HowReceivedCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.HowReceivedCodes; }
    static getSubmoduleRoleCodes(): Array<{ code: number, value: string }> { if (this.SubmoduleRoleCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.SubmoduleRoleCodes; }
    static getKerktonRoleCodes(): Array<{ code: number, value: string }> { if (this.KerktonRoleCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.KerktonRoleCodes; }
    static getOffenseCodes(): Array<{ code: number, value: string, sgCode: number, gCode: number, mgCode: number }> { if (this.OffenseCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.OffenseCodes; }
    static getNoteRecipientCodes(): Array<{ code: string, value: string }> { if (this.NoteRecipientCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.NoteRecipientCodes; }
    static getPhoneTypeCodes(): Array<{ code: string, value: string }> { if (this.PhoneTypeCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.PhoneTypeCodes; }
    static getEmailTypeCodes(): Array<{ code: string, value: string }> { if (this.EmailTypeCodes.length === 0) { this.fillCodesFromAuthObject(); } return this.EmailTypeCodes; }
}

export const SelectableTimeZones: Array<{ code: string, value: string }> = [
    { code: "UTC", value: "(UTC 00:00/00: 00) - UTC" },
    { code: "America/Adak", value: "(UTC −10:00/−09:00) - USA/Adak" },
    { code: "America/Anchorage", value: "(UTC −09:00/−08:00) - USA/Anchorage" },
    { code: "America/Juneau", value: "(UTC −09:00/−08:00) - USA/Juneau" },
    { code: "America/Metlakatla", value: "(UTC −09:00/−08:00) - USA/Metlakatla" },
    { code: "America/Nome", value: "(UTC −09:00/−08:00) - USA/Nome" },
    { code: "America/Sitka", value: "(UTC −09:00/−08:00) - USA/Sitka" },
    { code: "America/Yakutat", value: "(UTC −09:00/−08:00) - USA/Yakutat" },
    { code: "America/Dawson", value: "(UTC −08:00/−07:00) - Canada/Dawson" },
    { code: "America/Vancouver", value: "(UTC −08:00/−07:00) - Canada/Vancouver" },
    { code: "America/Whitehorse", value: "(UTC −08:00/−07:00) - Canada/Whitehorse" },
    { code: "America/Tijuana", value: "(UTC −08:00/−07:00) - Mexico/Tijuana" },
    { code: "America/Los_Angeles", value: "(UTC −08:00/−07:00) - USA/Los_Angeles" },
    { code: "America/Creston", value: "(UTC −07:00/−07:00) - Canada/Creston" },
    { code: "America/Dawson_Creek", value: "(UTC −07:00/−07:00) - Canada/Dawson_Creek" },
    { code: "America/Fort_Nelson", value: "(UTC −07:00/−07:00) - Canada/Fort_Nelson" },
    { code: "America/Hermosillo", value: "(UTC −07:00/−07:00) - Mexico/Hermosillo" },
    { code: "America/Phoenix", value: "(UTC −07:00/−07:00) - USA/Phoenix" },
    { code: "America/Cambridge_Bay", value: "(UTC −07:00/−06:00) - Canada/Cambridge_Bay" },
    { code: "America/Edmonton", value: "(UTC −07:00/−06:00) - Canada/Edmonton" },
    { code: "America/Inuvik", value: "(UTC −07:00/−06:00) - Canada/Inuvik" },
    { code: "America/Yellowknife", value: "(UTC −07:00/−06:00) - Canada/Yellowknife" },
    { code: "America/Chihuahua", value: "(UTC −07:00/−06:00) - Mexico/Chihuahua" },
    { code: "America/Mazatlan", value: "(UTC −07:00/−06:00) - Mexico/Mazatlan" },
    { code: "America/Ojinaga", value: "(UTC −07:00/−06:00) - Mexico/Ojinaga" },
    { code: "America/Boise", value: "(UTC −07:00/−06:00) - USA/Boise" },
    { code: "America/Denver", value: "(UTC −07:00/−06:00) - USA/Denver" },
    { code: "America/Regina", value: "(UTC −06:00/−06:00) - Canada/Regina" },
    { code: "America/Swift_Current", value: "(UTC −06:00/−06:00) - Canada/Swift_Current" },
    { code: "America/Rainy_River", value: "(UTC −06:00/−05:00) - Canada/Rainy_River" },
    { code: "America/Rankin_Inlet", value: "(UTC −06:00/−05:00) - Canada/Rankin_Inlet" },
    { code: "America/Resolute", value: "(UTC −06:00/−05:00) - Canada/Resolute" },
    { code: "America/Winnipeg", value: "(UTC −06:00/−05:00) - Canada/Winnipeg" },
    { code: "America/Bahia_Banderas", value: "(UTC −06:00/−05:00) - Mexico/Bahia_Banderas" },
    { code: "America/Matamoros", value: "(UTC −06:00/−05:00) - Mexico/Matamoros" },
    { code: "America/Merida", value: "(UTC −06:00/−05:00) - Mexico/Merida" },
    { code: "America/Mexico_City", value: "(UTC −06:00/−05:00) - Mexico/Mexico_City" },
    { code: "America/Monterrey", value: "(UTC −06:00/−05:00) - Mexico/Monterrey" },
    { code: "America/Chicago", value: "(UTC −06:00/−05:00) - USA/Chicago" },
    { code: "America/Indiana/Knox", value: "(UTC −06:00/−05:00) - USA/Indiana/Knox" },
    { code: "America/Indiana/Tell_City", value: "(UTC −06:00/−05:00) - USA/Indiana/Tell_City" },
    { code: "America/Menominee", value: "(UTC −06:00/−05:00) - USA/Menominee" },
    { code: "America/North_Dakota/Beulah", value: "(UTC −06:00/−05:00) - USA/North_Dakota/Beulah" },
    { code: "America/North_Dakota/Center", value: "(UTC −06:00/−05:00) - USA/North_Dakota/Center" },
    { code: "America/North_Dakota/New_Salem", value: "(UTC −06:00/−05:00) - USA/North_Dakota/New_Salem" },
    { code: "America/Atikokan", value: "(UTC −05:00/−05:00) - Canada/Atikokan" },
    { code: "America/Cancun", value: "(UTC −05:00/−05:00) - Mexico/Cancun" },
    { code: "America/Iqaluit", value: "(UTC −05:00/−04:00) - Canada/Iqaluit" },
    { code: "America/Nipigon", value: "(UTC −05:00/−04:00) - Canada/Nipigon" },
    { code: "America/Pangnirtung", value: "(UTC −05:00/−04:00) - Canada/Pangnirtung" },
    { code: "America/Thunder_Bay", value: "(UTC −05:00/−04:00) - Canada/Thunder_Bay" },
    { code: "America/Toronto", value: "(UTC −05:00/−04:00) - Canada/Toronto" },
    { code: "America/Detroit", value: "(UTC −05:00/−04:00) - USA/Detroit" },
    { code: "America/Indiana/Indianapolis", value: "(UTC −05:00/−04:00) - USA/Indiana/Indianapolis" },
    { code: "America/Indiana/Marengo", value: "(UTC −05:00/−04:00) - USA/Indiana/Marengo" },
    { code: "America/Indiana/Petersburg", value: "(UTC −05:00/−04:00) - USA/Indiana/Petersburg" },
    { code: "America/Indiana/Vevay", value: "(UTC −05:00/−04:00) - USA/Indiana/Vevay" },
    { code: "America/Indiana/Vincennes", value: "(UTC −05:00/−04:00) - USA/Indiana/Vincennes" },
    { code: "America/Indiana/Winamac", value: "(UTC −05:00/−04:00) - USA/Indiana/Winamac" },
    { code: "America/Kentucky/Louisville", value: "(UTC −05:00/−04:00) - USA/Kentucky/Louisville" },
    { code: "America/Kentucky/Monticello", value: "(UTC −05:00/−04:00) - USA/Kentucky/Monticello" },
    { code: "America/New_York", value: "(UTC −05:00/−04:00) - USA/New_York" },
    { code: "America/Blanc-Sablon", value: "(UTC −04:00/−04:00) - Canada/Blanc-Sablon" },
    { code: "America/Glace_Bay", value: "(UTC −04:00/−03:00) - Canada/Glace_Bay" },
    { code: "America/Goose_Bay", value: "(UTC −04:00/−03:00) - Canada/Goose_Bay" },
    { code: "America/Halifax", value: "(UTC −04:00/−03:00) - Canada/Halifax" },
    { code: "America/Moncton", value: "(UTC −04:00/−03:00) - Canada/Moncton" },
    { code: "America/St_Johns", value: "(UTC −03:30/−02:30) - Canada/St_Johns" },
    { code: "Australia/Lord_Howe", value: "(UTC +10:30/+11:00) - Australia/Lord_Howe" },
    { code: "Australia/Currie", value: "(UTC +10:00/+11:00) - Australia/Currie" },
    { code: "Australia/Hobart", value: "(UTC +10:00/+11:00) - Australia/Hobart" },
    { code: "Australia/Melbourne", value: "(UTC +10:00/+11:00) - Australia/Melbourne" },
    { code: "Australia/Sydney", value: "(UTC +10:00/+11:00) - Australia/Sydney" },
    { code: "Australia/Brisbane", value: "(UTC +10:00/+10:00) - Australia/Brisbane" },
    { code: "Australia/Lindeman", value: "(UTC +10:00/+10:00) - Australia/Lindeman" },
    { code: "Australia/Adelaide", value: "(UTC +09:30/+10:30) - Australia/Adelaide" },
    { code: "Australia/Broken_Hill", value: "(UTC +09:30/+10:30) - Australia/Broken_Hill" },
    { code: "Australia/Darwin", value: "(UTC +09:30/+09:30) - Australia/Darwin" },
    { code: "Australia/Eucla", value: "(UTC +08:45/+08:45) - Australia/Eucla" },
    { code: "Australia/Perth", value: "(UTC +08:00/+08:00) - Australia/Perth" },
];

// Day-of-month parity filter for a tour stop (orthogonal to the weekday mask).
// Labeled as "dates" (of the month) to avoid colliding with the weekday "days" selector.
export const SelectableEnabledTourStopDaysTypes = [
    { code: 1, value: "All dates" },
    { code: 2, value: "Even-numbered dates" },
    { code: 3, value: "Odd-numbered dates" },
];

export const heightUnits: Array<{ code: string, value: string }> = [
    {
        code: "ft",
        value: "Feet"
    },
    {
        code: "m",
        value: "Meters"
    }
];

export const weightUnits: Array<{ code: string, value: string }> = [
    {
        code: "lbs",
        value: "Pounds"
    },
    {
        code: "kg",
        value: "Kilograms"
    }
];

// Phone/email types: use backend-sourced codes when available, fall back to hardcoded defaults
const _defaultPhoneOptionTypes: Array<{ code: string, value: string }> = [
    { code: "M", value: "Mobile" },
    { code: "H", value: "Home" },
    { code: "W", value: "Work" },
    { code: "MAIN", value: "Main" },
    { code: "SEC", value: "Security" },
    { code: "HQ", value: "HQ" },
    { code: "LO", value: "Leasing Office" },
    { code: "MAINT", value: "Maintenance" },
    { code: "AE", value: "After Hours Emergency" },
    { code: "AM", value: "After Hours Property Manager" },
    { code: "PRI", value: "Primary" },
    { code: "SECOND", value: "Secondary" },
    { code: "KEY", value: "Key Holder" },
];
const _defaultEmailOptionTypes: Array<{ code: string, value: string }> = [
    { code: "P", value: "Personal" },
    { code: "W", value: "Work" },
    { code: "MAIN", value: "Main" },
    { code: "SEC", value: "Security" },
];

export function getPhoneOptionTypes(): Array<{ code: string, value: string }> {
    const backendCodes = Codes.getPhoneTypeCodes();
    return backendCodes.length > 0 ? backendCodes : _defaultPhoneOptionTypes;
}
export function getEmailOptionTypes(): Array<{ code: string, value: string }> {
    const backendCodes = Codes.getEmailTypeCodes();
    return backendCodes.length > 0 ? backendCodes : _defaultEmailOptionTypes;
}

// Legacy exports for backward compatibility
export const PhoneOptionTypes = _defaultPhoneOptionTypes;
export const EmailOptionTypes = _defaultEmailOptionTypes;
export const WarningPriorities: Array<{ code: number, value: string }> = [
    {
        code: 100,
        value: "Low"
    },
    {
        code: 200,
        value: "Medium"
    },
    {
        code: 300,
        value: "High"
    }
];

export class ModuleType {
    static cad: string = "cad";
    static mdt: string = "mdt";
    static admin: string = "admin";
}

export enum Byte {
    "Yes" = 1,
    "No" = 2,
    "N/A" = 3
}

export enum ChatType {
    All = 1,
    MDT = 2,
    CAD = 3
}

export const WeekDays: Array<WeekDay> = [
    { value: "Sunday", show: false, dayOfWeek: 1 },
    { value: "Monday", show: false, dayOfWeek: 2 },
    { value: "Tuesday", show: false, dayOfWeek: 3 },
    { value: "Wednesday", show: false, dayOfWeek: 4 },
    { value: "Thursday", show: false, dayOfWeek: 5 },
    { value: "Friday", show: false, dayOfWeek: 6 },
    { value: "Saturday", show: false, dayOfWeek: 7 }
]

export class WeekDay {
    value: string;
    show: boolean;
    dayOfWeek: number;
}

export enum OfficerCommentsRequired {
    REQUIRED = 1,
    OPTIONAL = 2,
    DISABLED = 3
}

export const OfficerAttachmentsEnabled = {
    ENABLED: true,
    DISABLED: false
};

export enum EnabledTourStopDaysType {
    ALL_DAYS = 1,
    EVEN_DAYS = 2,
    ODD_DAYS = 3
}

export enum AccountEnabledStates {
    NOT_EXPIRED = 0,
    UNKNOWN = 1,
    DISABLED_BY_USER = 2,
    LOCKED_BY_USER = 3
}

export const KST_AUTHENTICATE_HEADER = 'Kst-Authenticate'

export const UnauthorizedErrors = {
    USER_ACCOUNT_EXPIRED: 'User Account Expired',
    USER_ACCOUNT_DISABLED: 'User Account Login Disabled',
    ORG_DISABLED: 'Org Disabled'
};

// Window registrations
(window as any).Codes = Codes;
(window as any).ModuleType = ModuleType;
(window as any).WarningPriorities = WarningPriorities;
(window as any).SelectableTimeZones = SelectableTimeZones;
(window as any).SelectableEnabledTourStopDaysTypes = SelectableEnabledTourStopDaysTypes;
(window as any).heightUnits = heightUnits;
(window as any).weightUnits = weightUnits;
(window as any).PhoneOptionTypes = PhoneOptionTypes;
(window as any).EmailOptionTypes = EmailOptionTypes;
(window as any).Byte = Byte;
(window as any).ChatType = ChatType;
(window as any).WeekDays = WeekDays;
(window as any).WeekDay = WeekDay;
(window as any).OfficerCommentsRequired = OfficerCommentsRequired;
(window as any).OfficerAttachmentsEnabled = OfficerAttachmentsEnabled;
(window as any).EnabledTourStopDaysType = EnabledTourStopDaysType;
(window as any).AccountEnabledStates = AccountEnabledStates;
(window as any).KST_AUTHENTICATE_HEADER = KST_AUTHENTICATE_HEADER;
(window as any).UnauthorizedErrors = UnauthorizedErrors;
